export default "__VITE_PUBLIC_ASSET__999f199c__"